// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Dvr36","sendOtp":"AuthorizeToLogin_sendOtp__2qSIj"};